goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Settings$default");
shadow.js.shim.module$$carbon$icons_react$es$Settings$default = shadow.js.require(371, {}).default;
